import axiosBackend from "core/api/backend";

export default function LoadRolesList({
    appUUID,
}) {
    return axiosBackend({
        method: "POST",
        url: `/service/sites-that-users-control/roles/${appUUID}/`,
    })
}